import * as THREE from 'three';

export function makeLabelTexture(
  lines: string[],
  options: { width?: number; height?: number; background?: string; color?: string; accent?: string } = {}
): THREE.CanvasTexture {
  const width = options.width ?? 768;
  const height = options.height ?? 256;
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d')!;
  ctx.fillStyle = options.background ?? '#11151b';
  ctx.fillRect(0, 0, width, height);
  ctx.strokeStyle = options.accent ?? '#42d9ff';
  ctx.lineWidth = 8;
  ctx.strokeRect(8, 8, width - 16, height - 16);
  ctx.fillStyle = options.color ?? '#eaf8ff';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  const lineHeight = height / (lines.length + 0.5);
  lines.forEach((line, i) => {
    ctx.font = `${i === 0 ? 700 : 500} ${Math.floor(lineHeight * 0.48)}px ui-monospace, monospace`;
    ctx.fillText(line, width / 2, lineHeight * (i + 0.75));
  });
  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.anisotropy = 4;
  return texture;
}

export function labelPlane(lines: string[], width: number, height: number, options = {}): THREE.Mesh {
  const material = new THREE.MeshBasicMaterial({
    map: makeLabelTexture(lines, options),
    transparent: true,
    side: THREE.DoubleSide
  });
  const mesh = new THREE.Mesh(new THREE.PlaneGeometry(width, height), material);
  return mesh;
}

export function roundedBox(width: number, height: number, depth: number, radius: number): THREE.ExtrudeGeometry {
  const shape = new THREE.Shape();
  const x = -width / 2;
  const y = -height / 2;
  shape.moveTo(x + radius, y);
  shape.lineTo(x + width - radius, y);
  shape.quadraticCurveTo(x + width, y, x + width, y + radius);
  shape.lineTo(x + width, y + height - radius);
  shape.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  shape.lineTo(x + radius, y + height);
  shape.quadraticCurveTo(x, y + height, x, y + height - radius);
  shape.lineTo(x, y + radius);
  shape.quadraticCurveTo(x, y, x + radius, y);
  return new THREE.ExtrudeGeometry(shape, { depth, bevelEnabled: true, bevelSize: radius * 0.18, bevelThickness: radius * 0.12, bevelSegments: 2 });
}
